import { modalTypes } from "constants/types";
import localhost from "apis/localhost";
import { changePasswordConfirmationModal } from "components/Modal/confModalTypes";
import {
  addToJobQueue,
  clearJobQueue,
  currentSessionInfo,
} from "slices/app/appSlice";
import { showModal, hideModal } from "slices/app/actions/modals";
import { showErrorModal } from "slices/app/actions/error";

export const setWorkspace = (workspaceId) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  const formData = new FormData();
  formData.append("workspaceId", workspaceId);

  await localhost
    .post("/docs/setWorkspace", formData)
    .then(async (response) => {
      const { data } = response;
      window.location.href = data;
    })
    .catch((error) => {
      if (error.status === 401 || error.status === 403) {
        window.location.href = "/login.jsp?timeout=true";
      } else if (error.status === 901 || error.status === 902) {
        window.location.href = `/login.jsp?invalidSession=${error.status}`;
      }
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const changePassword =
  (oldPassword, newPassword) => async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));

    await localhost
      .post(
        "/docs/changePassword",
        {
          oldPassword,
          newPassword,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(async () => {
        dispatch(
          showModal(
            modalTypes.CONFIRMATION,
            changePasswordConfirmationModal(dispatch)
          )
        );
        dispatch(hideModal(modalTypes.CHANGE_PASSWORD));
      })
      .catch((error) => {
        dispatch(hideModal(modalTypes.CHANGE_PASSWORD));
        dispatch(showErrorModal(error));
      })
      .finally(() => {
        dispatch(clearJobQueue());
      });
  };

export const changePasswordDirect =
  (handleSuccess, handleFailure, oldPassword, newPassword) =>
  async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));
    await localhost
      .post(
        "/docs/changePassword",
        {
          oldPassword,
          newPassword,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(handleSuccess)
      .catch((e) => {
        handleFailure(e);
      })
      .finally(() => {
        dispatch(clearJobQueue());
      });
  };

export const forgotPassword =
  (handleSuccess, handleFailure, usermail) => async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));
    await localhost
      .post(
        "/docs/password/generate",
        {
          usermail,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(handleSuccess)
      .catch(() => {
        handleFailure();
      })
      .finally(() => {
        dispatch(clearJobQueue());
      });
  };

export const resetPassword =
  (handleSuccess, handleFailure, token, userNewPassword) =>
  async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));
    await localhost
      .post(
        "/docs/password/reset",
        {
          token,
          userNewPassword,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(handleSuccess)
      .catch(() => {
        handleFailure();
      })
      .finally(() => {
        dispatch(clearJobQueue());
      });
  };

export const getSessionInfo = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));
  await localhost
    .get("/docs/info")
    .then(async (response) => {
      const { data } = response;
      const csrf = {};
      csrf[data?.csrf?.header] = data?.csrf?.value;
      Object.assign(localhost.defaults.headers.common, csrf);
      dispatch(currentSessionInfo(data));
    })
    .catch(() => {
      // TODO: couple lines needed here to complete this future tasks ahead 2 weeks away
      dispatch(currentSessionInfo(null));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};
